import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StatusBullet} from '@/features/projects/components/status-bullet/StatusBullet'
import {ProjectExtended} from '@/features/projects/types'
import {projectStatusToLabel} from '@/features/projects/utils'
import {RenewedTooltip} from '@/features/projects/components/renewed-tooltip/RenewedTooltip'
import {useTranslation} from '@/translations/i18n'
import {RenewalTooltip} from '../renewal-tooltip/RenewalTooltip'

export const ProjectDetailsHeaderTitle = ({project}: {project: ProjectExtended}) => {
    const {t} = useTranslation()

    // Only one "outgoing operation" badge can be shown at a time. A closed cyclic project can be both
    // extended and separately reopened with variations, so extension takes priority over the rest.
    const isExtended = project.type === 'cyclic' && !!project.renewedAt && !!project.renewedProjectId

    return (
        <Flexbox align="center" gap={3}>
            <span>
                {t('projects:details_title', {
                    code: project.code,
                    patientFullName: project.patient.fullName
                })}
            </span>
            <Flexbox align="center" gap={2}>
                <StatusBullet status={project.status} />
                <Text palette="neutral" shade="600" size="textSm" weight="400">
                    {/* todo: remove the condition as soon as status is not optional anymore */}
                    {project.status && t(projectStatusToLabel[project.status])}
                </Text>
                {isExtended && project.renewedProjectId ? (
                    <RenewedTooltip renewedProjectId={project.renewedProjectId} operation="extension" />
                ) : project.isRenewed && project.renewedProjectId ? (
                    <RenewedTooltip renewedProjectId={project.renewedProjectId} operation="renew" />
                ) : project.isVaried && project.variedProjectId ? (
                    <RenewedTooltip renewedProjectId={project.variedProjectId} operation="variation" />
                ) : project.isTransformed && project.transformedProjectId ? (
                    <RenewedTooltip renewedProjectId={project.transformedProjectId} operation="transformation" />
                ) : (
                    !project.isRenewed &&
                    !project.isVaried &&
                    !project.isTransformed &&
                    project.projectRefId &&
                    project.projectRefType &&
                    project.type && (
                        <RenewalTooltip
                            projectId={project.projectRefId}
                            projectRefType={project.projectRefType}
                            projectType={project.type}
                        />
                    )
                )}
            </Flexbox>
        </Flexbox>
    )
}
